import moment from 'moment';
import config from '../../../config';

export const getLastDays = () => {
    let list = [];

    for (let i = 0; i < config.defaultLastDays; i++) {
        let date = moment().subtract(i, 'day').format(config.reportDateFormat);

        list.push(date);
    }

    return list;
};
